import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useConfig, usePreloadImages } from '@@client/lib/hooks';
import { getFeaturedUrl, getFallbackUrlByPartType, MEDIA_SIZES } from '@@client/media/api';
import PartPhoto from './PartPhoto';
export default function PartPhotoFeatured(_ref) {
  var partInfo = _ref.partInfo,
      _ref$sizeSlug = _ref.sizeSlug,
      sizeSlug = _ref$sizeSlug === void 0 ? MEDIA_SIZES.PREVIEW : _ref$sizeSlug,
      onLoad = _ref.onLoad,
      otherPartPhotoProps = _objectWithoutProperties(_ref, ["partInfo", "sizeSlug", "onLoad"]);

  var config = useConfig();
  var fallbackUrl = getFallbackUrlByPartType(partInfo.partType);
  var url = getFeaturedUrl(config.media.apiUrl, sizeSlug, partInfo.inventoryId, partInfo.araVehicleId);
  var isFullLoaded = usePreloadImages([url]);
  return /*#__PURE__*/_jsx(PartPhoto, _objectSpread({
    partInfo: partInfo,
    src: isFullLoaded ? url : fallbackUrl
  }, otherPartPhotoProps));
}